import React from "react";
import {
  Pagination, PaginationContent, PaginationItem, PaginationLink,
  PaginationPrevious, PaginationNext, PaginationEllipsis,
} from "../ui/pagination";

/** Build a compact page list with ellipses, e.g. [1, '…', 4, 5, 6, '…', 20] */
function pageList(current, totalPages) {
  const out = [];
  const push = (v) => out.push(v);
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) push(i);
    return out;
  }
  push(1);
  if (current > 3) push("start-ellipsis");
  const from = Math.max(2, current - 1);
  const to = Math.min(totalPages - 1, current + 1);
  for (let i = from; i <= to; i++) push(i);
  if (current < totalPages - 2) push("end-ellipsis");
  push(totalPages);
  return out;
}

/**
 * Right-aligned pagination control.
 * Props: page (1-based), total (row count), pageSize, onPageChange(nextPage), testid
 */
export default function TablePagination({ page, total, pageSize = 50, onPageChange, testid = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if (totalPages <= 1) return null;
  const go = (p) => (e) => { e?.preventDefault?.(); if (p >= 1 && p <= totalPages && p !== page) onPageChange(p); };

  return (
    <Pagination className="mx-0 w-auto justify-end" data-testid={testid}>
      <PaginationContent>
        <PaginationItem>
          <PaginationPrevious
            href="#"
            onClick={go(page - 1)}
            aria-disabled={page <= 1}
            className={page <= 1 ? "pointer-events-none opacity-50" : "cursor-pointer"}
          />
        </PaginationItem>
        {pageList(page, totalPages).map((p, i) =>
          typeof p === "string" ? (
            <PaginationItem key={p + i}><PaginationEllipsis /></PaginationItem>
          ) : (
            <PaginationItem key={p}>
              <PaginationLink
                href="#"
                isActive={p === page}
                onClick={go(p)}
                className="cursor-pointer"
                data-testid={`${testid}-page-${p}`}
              >
                {p}
              </PaginationLink>
            </PaginationItem>
          )
        )}
        <PaginationItem>
          <PaginationNext
            href="#"
            onClick={go(page + 1)}
            aria-disabled={page >= totalPages}
            className={page >= totalPages ? "pointer-events-none opacity-50" : "cursor-pointer"}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}
